import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { runWithAdal } from "react-adal";
import { authContext } from "./adalconfig";
import "bootstrap/dist/css/bootstrap.css";
import TosApp from "./Tos";
import Configure from "./Components/configure";
import { autenticate } from "./Services/authService";

const DO_NOT_LOGIN = false;
const url = window.document.URL;

const inTeams = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

if (inTeams()) {
  if (window.location.href.indexOf("configure") <= -1) {
    ReactDOM.render(autenticate(), document.getElementById("root"));
  } else {
    ReactDOM.render(<Configure></Configure>, document.getElementById("root"));
  }
} else {
  if (
    !url.toLowerCase().includes("termsandconditions") &&
    !url.toLowerCase().includes("termsofuse")
  ) {
    runWithAdal(
      authContext,
      () => {
        ReactDOM.render(
          <App />,
          document.getElementById("root") as HTMLElement
        );
        serviceWorker.register();
      },
      DO_NOT_LOGIN
    );
  } else if (
    url.toLowerCase().includes("termsandconditions") ||
    url.toLowerCase().includes("termsofuse")
  ) {
    ReactDOM.render(<TosApp />, document.getElementById("root"));

    serviceWorker.register();
  }
}
